<div
  #inputGroup
  [class.form-inline]="horizontal"
  role="radiogroup"
  [attr.aria-labelledby]="labelledBy"
>
  @for (radiobutton of radiobuttonObjects; track trackByFn(i); let i = $index) {
    <div
      class="form-check position-relative"
      [class.single-radio]="radiobuttonObjects.length === 1"
      [class.horizontal]="horizontal"
    >
      @if (showChangeIndicator && radioId === radiobutton.id) {
        <lib-dot-indicator type="radiobutton" [isVisible]="true" />
      }
      <div class="position-relative">
        <input
          [attr.aria-required]="required"
          [class]="size"
          [class.invalid]="error"
          (change)="updateValue($event)"
          class="form-check-input"
          type="radio"
          [attr.name]="name"
          [attr.id]="'id-' + labelPrefix + radiobutton.id"
          [disabled]="radiobutton.disabled"
          (focus)="onFocus($event)"
          (blur)="onBlur($event)"
          [value]="radiobutton.value ?? radiobutton.id"
          [attr.data-value]="radiobutton.id"
          [checked]="radioId === radiobutton.id"
        />
        <div class="position-absolute top-0 left-0 focus-container"></div>
      </div>
      <label
        [for]="'id-' + labelPrefix + radiobutton.id"
        class="form-check-label"
        [class]="size"
        >{{ radiobutton.label }}</label
      >
      <div class="break"></div>
      @if (radiobutton.descriptionInnerHTML) {
        <div
          class="radiobutton-description"
          [innerHTML]="radiobutton.descriptionInnerHTML"
        ></div>
      }
    </div>
  }
</div>
